<ng-container *adaptLoading="!isInitialised">
    @if (teamMembers.length > 1) {
        <adapt-menu adaptToolbarContent
                    [items]="menuItems"></adapt-menu>
    }
    <dx-accordion [dataSource]="teamMembers"
                  [multiple]="true"
                  [collapsible]="true"
                  keyExpr="personId"
                  (selectedItemKeysChange)="onAccordionExpansionChanged($event)">
        <div *dxTemplate="let person of 'title'"
             class="d-flex align-items-center">
            <h2 class="my-0 d-flex align-items-center gap-1"
                [ngClass]="{ 'new-page': indexOf(person) > 0 }">
                <adapt-link-person [person]="person"
                                   [showImage]="true"
                                   imageSize="sm"
                                   [linkDisabled]="true"></adapt-link-person>
                @if (canEditTeamVision) {
                    <button adaptButton="editBorderless"
                            class="smaller-vision-button-text"
                            adaptStopPropagation
                            (click)="editVisionForPerson(person.personId)"></button>
                }
                @if (personCompletionStatus[person.personId]) {
                    <ng-container *ngTemplateOutlet="showCompletedTick"></ng-container>
                }
            </h2>

            @if (expandedPersonIds.includes(person.personId)) {
                <div class="d-flex gap-3 ms-auto me-4"
                     adaptStopPropagation>
                    <button class="small"
                            adaptButton="expandLink"
                            (click)="expandPerson(person.personId)">Expand categories</button>
                    <button class="small"
                            adaptButton="collapseLink"
                            (click)="collapsePerson(person.personId)">Collapse categories</button>
                </div>
            }
        </div>
        <div *dxTemplate="let person of 'item'"
             class="pt-2">
            <adapt-category-vision-accordion [personId]="person.personId"
                                             [personColorIndex]="indexOf(person)"
                                             [teamId]="teamId"
                                             [indicateIncompleteCategories]="true"
                                             (initialised)="personAccordionInitialised(person.personId, $event)"></adapt-category-vision-accordion>
        </div>
    </dx-accordion>

    <ng-template #showCompletedTick>
        <i class="ms-2 fal fa-fw fa-check text-success"
           adaptTooltip="Completed"></i>
    </ng-template>
</ng-container>
